module.exports = __webpack_public_path__ + "fonts/lato-regular.f9875f1f.woff2";